// Shared TanStack Query keys for the release-checklist domain. Kept in one
// place so every hook file (queries, releaseMutations, sectionMutations,
// templateMutations) writes to the same cache buckets.

export const RELEASES_KEY = ['releases'] as const;

export const checklistKey = (release: string) =>
  ['checklist', release] as const;

export const TEMPLATE_BACKUPS_KEY = ['default-template', 'backups'] as const;

export const RELEASE_BACKUPS_KEY = ['release-checklist', 'backups'] as const;
